<template>
  <div class="warranty">
    <template v-if="metas && metas.emission.value === '纯电*'">
      <div class="warranty-block">
        <div class="prefix-block">
          *
        </div>
        <div class="warranty-content">
          新能源车和纯电车以原厂质保为准，需了解质保详情请联系销售顾问
        </div>
      </div>
    </template>
    <template v-else>
      <!--
        2025.07.18
        - 质保备注（纯电不展示）
      -->
      <div class="warranty-block warranty-block--blue">
        <div class="prefix-block">*</div>
        <div class="warranty-content">
          自2022年2月起，自营车保障由第三方采购整体切换为诺诺直接承保，该节点之后购买的自营车出现理赔故障，直接联系诺诺即可。
        </div>
      </div>
      <div class="warranty-block">
        <div class="prefix-block">
          *
        </div>
        <div class="warranty-content">
          默认提供长达 1 年的核心系统质保，可全国理赔，涉及：
        </div>
      </div>
      <div class="warranty-block">
        <div class="prefix-block" />
        <div class="warranty-category-list-wrapper">
          <div class="warranty-category-list">
            <div class="warranty-category-list-item">
              • 发动机
            </div>
            <div class="warranty-category-list-item">
              • 电气系统
            </div>
            <div class="warranty-category-list-item">
              • 万向节
            </div>

            <div class="warranty-category-list-item">
              • 变速箱
            </div>
            <div class="warranty-category-list-item">
              • 转向系统
            </div>
            <div class="warranty-category-list-item">
              • 发动机ECU
            </div>

            <div class="warranty-category-list-item">
              • 差速器
            </div>
            <div class="warranty-category-list-item">
              • 燃油系统
            </div>
            <div class="warranty-category-list-item">
              • ABS系统
            </div>

            <div class="warranty-category-list-item">
              • 涡轮增压器
            </div>
            <div class="warranty-category-list-item">
              • 点火系统
            </div>
            <div class="warranty-category-list-item">
              • 冷却系统
            </div>

            <div class="warranty-category-list-item">
              • 空调系统
            </div>
            <div class="warranty-category-list-item">
              • 制动系统
            </div>
            <div class="warranty-category-list-item">
              • 传动轴
            </div>
          </div>
        </div>
      </div>
      <div class="warranty-block">
        <div class="prefix-block">
          *
        </div>
        <div class="warranty-content">
          推荐增购质保升级套餐，包括<span class="warranty-bold">更广的覆盖面、更高的赔额</span>，以及<span class="warranty-bold">更长的保障时间</span>，让后期更加省心省钱，具体请咨询销售顾问；
        </div>
      </div>
      <div class="warranty-block">
        <div class="prefix-block">
          *
        </div>
        <div class="warranty-content">
          具体保障细节及理赔指南，请见该车销售合同或附件；
        </div>
      </div>
      <div class="warranty-block">
        <div class="prefix-block">
          *
        </div>
        <div class="warranty-content">
          个别车辆可能因年份或里程超限而无法提供质保，购车前均会明确告知；
        </div>
      </div>
      <div class="warranty-block">
        <div class="prefix-block">
          *
        </div>
        <div class="warranty-content">
          还在原厂质保期或延保期内的自营车，我方质保将被原厂保障取代；
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Warranty',

  computed: {
    ...mapGetters('Car', [
      'metasByCarId',
    ]),

    // metas
    metas () {
      return this.metasByCarId(this.$route.params.id)
    },
  },
}
</script>

<style lang="scss" scoped>

.warranty {
  box-sizing: border-box;
  color: #616161;
  line-height: 1.425;
  font-size: 0.95rem;
  position: relative;
}

.pf-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  background: rgba(255, 255, 255, .85);
  display: flex;
}

.pf-desc {
  margin: auto;
  font-size: 1.6rem;
  font-weight: bold;
  color: #EB474D;
  padding: 8px 16px;
  border: 2px #EB474D solid;
  border-radius: 10px;
}

.warranty-block {
  display: flex;
  flex-flow: row nowrap;
  margin-bottom: 5px;
}

.warranty-bold {
  font-weight: bolder;
  color: #030303;
}

.prefix-block {
  flex-basis: 12px;
  text-align: left;
}

.warranty-content {
  flex: 1;
}

.warranty-category-list-wrapper {
  flex: 1;
  background: #e8ecf8;
}

.warranty-category-list {
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row wrap;
}

.warranty-category-list-item {
  padding: 2px 0;
  box-sizing: border-box;
  flex-basis: 33.33%;
  font-size: 0.95rem;
}

.warranty-block.warranty-block--blue {
  color: #2e77b3;
}

@media (min-width: 640px) {
  .section-content-warranty {
    font-size: 1rem;
  }

  .warranty-block {
    margin-bottom: 10px;
  }
}

@media (prefers-color-scheme: dark) {
  .warranty {
    color: var(--black-primary);
  }

  .warranty-bold {
    color: var(--black-primary);
  }

  .warranty-category-list {
    background: #1A1A1A;
  }

  .warranty-block.warranty-block--blue {
    color: #b0d4f7;
  }
}
</style>
